import './Info.scss'
import Telegram from '../../assets/navbar/icons8-telegram-app (2).svg'
import Instagram from '../../assets/navbar/icons8-instagram (3).svg'
import Location from '../../assets/navbar/location.png'
import Dostavka from '../../assets/navbar/call-center-service (1).png'
const Info = () => {
    return (
        <div className={'info-father'}>
            <div className="info-block">
                <a target={'_blank'} href="https://t.me/sofcafe_bot">
                    <div className="info-boxes">Telegram
                        <img src={Telegram} alt=""/>
                    </div>
                </a>
                <a target={'_blank'} href="https://www.instagram.com/sofcafe.uz/">
                    <div className="info-boxes">Instagram
                        <img src={Instagram} alt=""/>
                    </div>
                </a>
                <a target={'_blank'} href="tel:+998555010700">
                    <div className="info-boxes">Доставка
                        <img src={Dostavka} alt=""/>
                    </div>
                </a>
                <a target={'_blank'}
                   href="https://www.google.com/maps/place/Sof/@41.223473,69.211842,15z/data=!4m6!3m5!1s0x38ae61ee952be88d:0x7011a6082bd19835!8m2!3d41.223473!4d69.211842!16s%2Fg%2F11tdhrmx51?hl=ru&coh=178572&entry=tt&shorturl=1">
                    <div className="info-boxes">Локация
                        <img src={Location} alt=""/>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default Info;